// This file is auto-generated by running bin/generate-bindings.
// DO NOT EDIT THIS FILE OR DO NOT UPDATE THIS FILE IN ANY OTHER WAY THAN BY RUNNING bin/generate-bindings.
//
// Since this file is auto-generated, any changes you make to it will be overwritten by the next run of bin/generate-bindings.

import { type DefaultError, queryOptions, type UseMutationOptions } from "@tanstack/react-query"

import { client } from "../client.generated"
import {
  acknowledgeAiUsageNotice,
  allUserConversations,
  claimCodeFromCodeGiveaway,
  deleteCourseMaterialGlossaryTerm,
  endExamTime,
  enrollInExam,
  fetchExam,
  fetchExamEnrollment,
  fetchExamForTesting,
  fetchPeerOrSelfReviewDataByExerciseId,
  fetchPeerReviewDataReceivedByExerciseId,
  getAiUsageNoticeAcknowledgement,
  getCodeGiveawayStatus,
  getConversationInfo,
  getCourseMaterialAuthenticatedUserDetails,
  getCourseMaterialBackgroundQuestionsAndAnswers,
  getCourseMaterialChapterExerciseProgress,
  getCourseMaterialChapterFrontPage,
  getCourseMaterialChapterLockPreview,
  getCourseMaterialChapterPages,
  getCourseMaterialChapterPagesExcludingFrontPage,
  getCourseMaterialChapterPagesWithExercises,
  getCourseMaterialChapterProgress,
  getCourseMaterialChapters,
  getCourseMaterialCountryFromIp,
  getCourseMaterialCourse,
  getCourseMaterialCourseInstances,
  getCourseMaterialCourseModuleCompletionsForUser,
  getCourseMaterialCourseModulePointsBreakdown,
  getCourseMaterialCoursePageByPath,
  getCourseMaterialCoursePages,
  getCourseMaterialCustomPrivacyPolicyCheckboxTexts,
  getCourseMaterialDefaultModuleIdByCourseId,
  getCourseMaterialExercise,
  getCourseMaterialExerciseTasksByModuleAndType,
  getCourseMaterialGlossary,
  getCourseMaterialIsPageChapterFrontPage,
  getCourseMaterialLanguageVersionNavigationInfos,
  getCourseMaterialMentimeterOembed,
  getCourseMaterialModuleIdByChapterId,
  getCourseMaterialOrganization,
  getCourseMaterialPageAudioFiles,
  getCourseMaterialPageByCourseIdAndLanguageGroupId,
  getCourseMaterialPageByExamId,
  getCourseMaterialPageChapterAndCourseInformation,
  getCourseMaterialPageNavigation,
  getCourseMaterialPageUrlPath,
  getCourseMaterialPartnersBlock,
  getCourseMaterialPrivacyLink,
  getCourseMaterialReferences,
  getCourseMaterialResearchConsentForm,
  getCourseMaterialResearchConsentFormAnswers,
  getCourseMaterialResearchConsentFormQuestions,
  getCourseMaterialStudentCountries,
  getCourseMaterialStudentCountry,
  getCourseMaterialTopLevelPages,
  getCourseMaterialUserChapterLocks,
  getCourseMaterialUserCourseProgress,
  getCourseMaterialUserCourseSettings,
  getCourseMaterialUserMarketingConsent,
  getCourseMaterialUserModuleCompletions,
  getCurrentConversationId,
  getCurrentCourseMaterialCourseInstance,
  getDefaultChatbotConfigurationForCourse,
  lockCourseMaterialChapter,
  newChatbotConversation,
  type Options,
  postCourseMaterialCourseEditProposal,
  postCourseMaterialProposedEdits,
  postCourseMaterialResearchConsentFormAnswer,
  postCourseMaterialStudentCountry,
  postFeedback,
  postFlagAnswerInPeerReview,
  postPeerOrSelfReviewSubmission,
  postStartPeerOrSelfReview,
  postSubmission,
  resetExamProgress,
  saveCourseMaterialCourseSettings,
  searchPagesWithPhrase,
  searchPagesWithWords,
  sendChatbotMessage,
  sendChatbotToolResponse,
  updateCourseMaterialGlossaryTerm,
  updateCourseMaterialUserInfo,
  updateMarketingConsent,
  updateShowExerciseAnswers,
  updateTitle,
} from "../sdk.generated"
import type {
  AcknowledgeAiUsageNoticeData,
  AcknowledgeAiUsageNoticeResponse,
  AllUserConversationsData,
  AllUserConversationsResponse,
  ClaimCodeFromCodeGiveawayData,
  ClaimCodeFromCodeGiveawayResponse,
  DeleteCourseMaterialGlossaryTermData,
  EndExamTimeData,
  EnrollInExamData,
  FetchExamData,
  FetchExamEnrollmentData,
  FetchExamEnrollmentResponse,
  FetchExamForTestingData,
  FetchExamForTestingResponse,
  FetchExamResponse,
  FetchPeerOrSelfReviewDataByExerciseIdData,
  FetchPeerOrSelfReviewDataByExerciseIdResponse,
  FetchPeerReviewDataReceivedByExerciseIdData,
  FetchPeerReviewDataReceivedByExerciseIdResponse,
  GetAiUsageNoticeAcknowledgementData,
  GetAiUsageNoticeAcknowledgementResponse,
  GetCodeGiveawayStatusData,
  GetCodeGiveawayStatusResponse,
  GetConversationInfoData,
  GetConversationInfoResponse,
  GetCourseMaterialAuthenticatedUserDetailsData,
  GetCourseMaterialAuthenticatedUserDetailsResponse,
  GetCourseMaterialBackgroundQuestionsAndAnswersData,
  GetCourseMaterialBackgroundQuestionsAndAnswersResponse,
  GetCourseMaterialChapterExerciseProgressData,
  GetCourseMaterialChapterExerciseProgressResponse,
  GetCourseMaterialChapterFrontPageData,
  GetCourseMaterialChapterFrontPageResponse,
  GetCourseMaterialChapterLockPreviewData,
  GetCourseMaterialChapterLockPreviewResponse,
  GetCourseMaterialChapterPagesData,
  GetCourseMaterialChapterPagesExcludingFrontPageData,
  GetCourseMaterialChapterPagesExcludingFrontPageResponse,
  GetCourseMaterialChapterPagesResponse,
  GetCourseMaterialChapterPagesWithExercisesData,
  GetCourseMaterialChapterPagesWithExercisesResponse,
  GetCourseMaterialChapterProgressData,
  GetCourseMaterialChapterProgressResponse,
  GetCourseMaterialChaptersData,
  GetCourseMaterialChaptersResponse,
  GetCourseMaterialCountryFromIpData,
  GetCourseMaterialCountryFromIpResponse,
  GetCourseMaterialCourseData,
  GetCourseMaterialCourseInstancesData,
  GetCourseMaterialCourseInstancesResponse,
  GetCourseMaterialCourseModuleCompletionsForUserData,
  GetCourseMaterialCourseModuleCompletionsForUserResponse,
  GetCourseMaterialCourseModulePointsBreakdownData,
  GetCourseMaterialCourseModulePointsBreakdownResponse,
  GetCourseMaterialCoursePageByPathData,
  GetCourseMaterialCoursePageByPathResponse,
  GetCourseMaterialCoursePagesData,
  GetCourseMaterialCoursePagesResponse,
  GetCourseMaterialCourseResponse,
  GetCourseMaterialCustomPrivacyPolicyCheckboxTextsData,
  GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponse,
  GetCourseMaterialDefaultModuleIdByCourseIdData,
  GetCourseMaterialDefaultModuleIdByCourseIdResponse,
  GetCourseMaterialExerciseData,
  GetCourseMaterialExerciseResponse,
  GetCourseMaterialExerciseTasksByModuleAndTypeData,
  GetCourseMaterialExerciseTasksByModuleAndTypeResponse,
  GetCourseMaterialGlossaryData,
  GetCourseMaterialGlossaryResponse,
  GetCourseMaterialIsPageChapterFrontPageData,
  GetCourseMaterialIsPageChapterFrontPageResponse,
  GetCourseMaterialLanguageVersionNavigationInfosData,
  GetCourseMaterialLanguageVersionNavigationInfosResponse,
  GetCourseMaterialMentimeterOembedData,
  GetCourseMaterialMentimeterOembedResponse,
  GetCourseMaterialModuleIdByChapterIdData,
  GetCourseMaterialModuleIdByChapterIdResponse,
  GetCourseMaterialOrganizationData,
  GetCourseMaterialOrganizationResponse,
  GetCourseMaterialPageAudioFilesData,
  GetCourseMaterialPageAudioFilesResponse,
  GetCourseMaterialPageByCourseIdAndLanguageGroupIdData,
  GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponse,
  GetCourseMaterialPageByExamIdData,
  GetCourseMaterialPageByExamIdResponse,
  GetCourseMaterialPageChapterAndCourseInformationData,
  GetCourseMaterialPageChapterAndCourseInformationResponse,
  GetCourseMaterialPageNavigationData,
  GetCourseMaterialPageNavigationResponse,
  GetCourseMaterialPageUrlPathData,
  GetCourseMaterialPageUrlPathResponse,
  GetCourseMaterialPartnersBlockData,
  GetCourseMaterialPartnersBlockResponse,
  GetCourseMaterialPrivacyLinkData,
  GetCourseMaterialPrivacyLinkResponse,
  GetCourseMaterialReferencesData,
  GetCourseMaterialReferencesResponse,
  GetCourseMaterialResearchConsentFormAnswersData,
  GetCourseMaterialResearchConsentFormAnswersResponse,
  GetCourseMaterialResearchConsentFormData,
  GetCourseMaterialResearchConsentFormQuestionsData,
  GetCourseMaterialResearchConsentFormQuestionsResponse,
  GetCourseMaterialResearchConsentFormResponse,
  GetCourseMaterialStudentCountriesData,
  GetCourseMaterialStudentCountriesResponse,
  GetCourseMaterialStudentCountryData,
  GetCourseMaterialStudentCountryResponse,
  GetCourseMaterialTopLevelPagesData,
  GetCourseMaterialTopLevelPagesResponse,
  GetCourseMaterialUserChapterLocksData,
  GetCourseMaterialUserChapterLocksResponse,
  GetCourseMaterialUserCourseProgressData,
  GetCourseMaterialUserCourseProgressResponse,
  GetCourseMaterialUserCourseSettingsData,
  GetCourseMaterialUserCourseSettingsResponse,
  GetCourseMaterialUserMarketingConsentData,
  GetCourseMaterialUserMarketingConsentResponse,
  GetCourseMaterialUserModuleCompletionsData,
  GetCourseMaterialUserModuleCompletionsResponse,
  GetCurrentConversationIdData,
  GetCurrentConversationIdResponse,
  GetCurrentCourseMaterialCourseInstanceData,
  GetCurrentCourseMaterialCourseInstanceResponse,
  GetDefaultChatbotConfigurationForCourseData,
  GetDefaultChatbotConfigurationForCourseResponse,
  LockCourseMaterialChapterData,
  LockCourseMaterialChapterResponse,
  NewChatbotConversationData,
  NewChatbotConversationResponse,
  PostCourseMaterialCourseEditProposalData,
  PostCourseMaterialCourseEditProposalResponse,
  PostCourseMaterialProposedEditsData,
  PostCourseMaterialResearchConsentFormAnswerData,
  PostCourseMaterialResearchConsentFormAnswerResponse,
  PostCourseMaterialStudentCountryData,
  PostCourseMaterialStudentCountryResponse,
  PostFeedbackData,
  PostFeedbackResponse,
  PostFlagAnswerInPeerReviewData,
  PostFlagAnswerInPeerReviewResponse,
  PostPeerOrSelfReviewSubmissionData,
  PostPeerOrSelfReviewSubmissionResponse,
  PostStartPeerOrSelfReviewData,
  PostStartPeerOrSelfReviewResponse,
  PostSubmissionData,
  PostSubmissionResponse,
  ResetExamProgressData,
  SaveCourseMaterialCourseSettingsData,
  SaveCourseMaterialCourseSettingsResponse,
  SearchPagesWithPhraseData,
  SearchPagesWithPhraseResponse,
  SearchPagesWithWordsData,
  SearchPagesWithWordsResponse,
  SendChatbotMessageData,
  SendChatbotMessageResponse,
  SendChatbotToolResponseData,
  SendChatbotToolResponseResponse,
  UpdateCourseMaterialGlossaryTermData,
  UpdateCourseMaterialUserInfoData,
  UpdateCourseMaterialUserInfoResponse,
  UpdateMarketingConsentData,
  UpdateMarketingConsentResponse,
  UpdateShowExerciseAnswersData,
  UpdateTitleData,
} from "../types.generated"

export const deleteCourseMaterialGlossaryTermMutation = (
  options?: Partial<Options<DeleteCourseMaterialGlossaryTermData>>,
): UseMutationOptions<unknown, DefaultError, Options<DeleteCourseMaterialGlossaryTermData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<DeleteCourseMaterialGlossaryTermData>
  > = {
    mutationFn: async (fnOptions) =>
      await deleteCourseMaterialGlossaryTerm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const updateCourseMaterialGlossaryTermMutation = (
  options?: Partial<Options<UpdateCourseMaterialGlossaryTermData>>,
): UseMutationOptions<unknown, DefaultError, Options<UpdateCourseMaterialGlossaryTermData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateCourseMaterialGlossaryTermData>
  > = {
    mutationFn: async (fnOptions) =>
      await updateCourseMaterialGlossaryTerm({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string
    _infinite?: boolean
    tags?: ReadonlyArray<string>
  },
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (tags) {
    params.tags = tags
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const getCourseMaterialChapterPagesWithExercisesQueryKey = (
  options: Options<GetCourseMaterialChapterPagesWithExercisesData>,
) => createQueryKey("getCourseMaterialChapterPagesWithExercises", options)

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/exercises` - Returns a list of pages and its exercises in chapter.
 */
export const getCourseMaterialChapterPagesWithExercisesOptions = (
  options: Options<GetCourseMaterialChapterPagesWithExercisesData>,
) =>
  queryOptions<
    GetCourseMaterialChapterPagesWithExercisesResponse,
    DefaultError,
    GetCourseMaterialChapterPagesWithExercisesResponse,
    ReturnType<typeof getCourseMaterialChapterPagesWithExercisesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterPagesWithExercises({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterPagesWithExercisesQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/chapters/:chapter_id/lock` - Complete chapter (mark as done)
 *
 * Completes a chapter for the authenticated user (marks it as done).
 *
 * Validates that:
 * - Course has chapter_locking_enabled
 * - Chapter is currently unlocked (student can work on it)
 * - All previous chapters in the same module are completed (sequential completion)
 * - Moves all exercises to manual review
 * - Unlocks next chapters for the user
 * *
 */
export const lockCourseMaterialChapterMutation = (
  options?: Partial<Options<LockCourseMaterialChapterData>>,
): UseMutationOptions<
  LockCourseMaterialChapterResponse,
  DefaultError,
  Options<LockCourseMaterialChapterData>
> => {
  const mutationOptions: UseMutationOptions<
    LockCourseMaterialChapterResponse,
    DefaultError,
    Options<LockCourseMaterialChapterData>
  > = {
    mutationFn: async (fnOptions) =>
      await lockCourseMaterialChapter({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialChapterLockPreviewQueryKey = (
  options: Options<GetCourseMaterialChapterLockPreviewData>,
) => createQueryKey("getCourseMaterialChapterLockPreview", options)

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/lock-preview` - Preview lock chapter
 *
 * Returns information about unreturned exercises in the chapter before locking.
 * *
 */
export const getCourseMaterialChapterLockPreviewOptions = (
  options: Options<GetCourseMaterialChapterLockPreviewData>,
) =>
  queryOptions<
    GetCourseMaterialChapterLockPreviewResponse,
    DefaultError,
    GetCourseMaterialChapterLockPreviewResponse,
    ReturnType<typeof getCourseMaterialChapterLockPreviewQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterLockPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterLockPreviewQueryKey(options),
  })

export const getCourseMaterialChapterPagesQueryKey = (
  options: Options<GetCourseMaterialChapterPagesData>,
) => createQueryKey("getCourseMaterialChapterPages", options)

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/pages` - Returns a list of pages in chapter.
 */
export const getCourseMaterialChapterPagesOptions = (
  options: Options<GetCourseMaterialChapterPagesData>,
) =>
  queryOptions<
    GetCourseMaterialChapterPagesResponse,
    DefaultError,
    GetCourseMaterialChapterPagesResponse,
    ReturnType<typeof getCourseMaterialChapterPagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterPages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterPagesQueryKey(options),
  })

export const getCourseMaterialChapterPagesExcludingFrontPageQueryKey = (
  options: Options<GetCourseMaterialChapterPagesExcludingFrontPageData>,
) => createQueryKey("getCourseMaterialChapterPagesExcludingFrontPage", options)

/**
 *
 * GET `/api/v0/course-material/chapters/:chapter_id/pages-exclude-mainfrontpage` - Returns a list of pages in chapter mainfrontpage excluded.
 */
export const getCourseMaterialChapterPagesExcludingFrontPageOptions = (
  options: Options<GetCourseMaterialChapterPagesExcludingFrontPageData>,
) =>
  queryOptions<
    GetCourseMaterialChapterPagesExcludingFrontPageResponse,
    DefaultError,
    GetCourseMaterialChapterPagesExcludingFrontPageResponse,
    ReturnType<typeof getCourseMaterialChapterPagesExcludingFrontPageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterPagesExcludingFrontPage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterPagesExcludingFrontPageQueryKey(options),
  })

export const allUserConversationsQueryKey = (options?: Options<AllUserConversationsData>) =>
  createQueryKey("allUserConversations", options)

/**
 *
 * GET `/api/v0/course-material/chatbot/conversations/all`
 *
 * Returns all conversations that a user has.
 */
export const allUserConversationsOptions = (options?: Options<AllUserConversationsData>) =>
  queryOptions<
    AllUserConversationsResponse,
    DefaultError,
    AllUserConversationsResponse,
    ReturnType<typeof allUserConversationsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await allUserConversations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: allUserConversationsQueryKey(options),
  })

export const getDefaultChatbotConfigurationForCourseQueryKey = (
  options: Options<GetDefaultChatbotConfigurationForCourseData>,
) => createQueryKey("getDefaultChatbotConfigurationForCourse", options)

/**
 *
 * GET `/api/v0/course-material/course-modules/chatbot/default-for-course/:course-id`
 *
 * Returns the default chatbot configuration id for a course if the default chatbot is enabled to students.
 */
export const getDefaultChatbotConfigurationForCourseOptions = (
  options: Options<GetDefaultChatbotConfigurationForCourseData>,
) =>
  queryOptions<
    GetDefaultChatbotConfigurationForCourseResponse,
    DefaultError,
    GetDefaultChatbotConfigurationForCourseResponse,
    ReturnType<typeof getDefaultChatbotConfigurationForCourseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getDefaultChatbotConfigurationForCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getDefaultChatbotConfigurationForCourseQueryKey(options),
  })

export const getConversationInfoQueryKey = (options: Options<GetConversationInfoData>) =>
  createQueryKey("getConversationInfo", options)

/**
 *
 * GET `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations`
 *
 * Returns a chatbot conversation for the user. If conversation id is not provided as a query parameter then latest conversation is returned.
 */
export const getConversationInfoOptions = (options: Options<GetConversationInfoData>) =>
  queryOptions<
    GetConversationInfoResponse,
    DefaultError,
    GetConversationInfoResponse,
    ReturnType<typeof getConversationInfoQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getConversationInfo({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getConversationInfoQueryKey(options),
  })

export const getCurrentConversationIdQueryKey = (options: Options<GetCurrentConversationIdData>) =>
  createQueryKey("getCurrentConversationId", options)

/**
 *
 * GET `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/current/id`
 *
 * Returns current chatbot conversation id.
 */
export const getCurrentConversationIdOptions = (options: Options<GetCurrentConversationIdData>) =>
  queryOptions<
    GetCurrentConversationIdResponse,
    DefaultError,
    GetCurrentConversationIdResponse,
    ReturnType<typeof getCurrentConversationIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCurrentConversationId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCurrentConversationIdQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/course-modules/chatbot/:chatbot_configuration_id/conversations/new`
 *
 * Sends a new chat message to the chatbot.
 */
export const newChatbotConversationMutation = (
  options?: Partial<Options<NewChatbotConversationData>>,
): UseMutationOptions<
  NewChatbotConversationResponse,
  DefaultError,
  Options<NewChatbotConversationData>
> => {
  const mutationOptions: UseMutationOptions<
    NewChatbotConversationResponse,
    DefaultError,
    Options<NewChatbotConversationData>
  > = {
    mutationFn: async (fnOptions) =>
      await newChatbotConversation({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/send-message`
 *
 * Sends a new chat message to the chatbot.
 */
export const sendChatbotMessageMutation = (
  options?: Partial<Options<SendChatbotMessageData>>,
): UseMutationOptions<
  SendChatbotMessageResponse,
  DefaultError,
  Options<SendChatbotMessageData>
> => {
  const mutationOptions: UseMutationOptions<
    SendChatbotMessageResponse,
    DefaultError,
    Options<SendChatbotMessageData>
  > = {
    mutationFn: async (fnOptions) =>
      await sendChatbotMessage({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/tool-response`
 *
 * Answers a tool call the chatbot suspended its turn on, which resumes the turn once nothing else
 * is outstanding. Responds with the same stream `send-message` does, carrying either the resumed
 * turn or a lone `Suspended` event when the turn is still waiting for another answer.
 */
export const sendChatbotToolResponseMutation = (
  options?: Partial<Options<SendChatbotToolResponseData>>,
): UseMutationOptions<
  SendChatbotToolResponseResponse,
  DefaultError,
  Options<SendChatbotToolResponseData>
> => {
  const mutationOptions: UseMutationOptions<
    SendChatbotToolResponseResponse,
    DefaultError,
    Options<SendChatbotToolResponseData>
  > = {
    mutationFn: async (fnOptions) =>
      await sendChatbotToolResponse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * PUT `/api/v0/course-material/chatbot/:chatbot_configuration_id/conversations/:conversation_id/update-title`
 *
 * Updates the title of a chatbot conversation.
 */
export const updateTitleMutation = (
  options?: Partial<Options<UpdateTitleData>>,
): UseMutationOptions<unknown, DefaultError, Options<UpdateTitleData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<UpdateTitleData>> = {
    mutationFn: async (fnOptions) =>
      await updateTitle({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST /api/v0/course-material/code-giveaways/:id/claim - Claim a code from a code giveaway. If user has not completed the course module that is a requirement for the code, returns an error.
 */
export const claimCodeFromCodeGiveawayMutation = (
  options?: Partial<Options<ClaimCodeFromCodeGiveawayData>>,
): UseMutationOptions<
  ClaimCodeFromCodeGiveawayResponse,
  DefaultError,
  Options<ClaimCodeFromCodeGiveawayData>
> => {
  const mutationOptions: UseMutationOptions<
    ClaimCodeFromCodeGiveawayResponse,
    DefaultError,
    Options<ClaimCodeFromCodeGiveawayData>
  > = {
    mutationFn: async (fnOptions) =>
      await claimCodeFromCodeGiveaway({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCodeGiveawayStatusQueryKey = (options: Options<GetCodeGiveawayStatusData>) =>
  createQueryKey("getCodeGiveawayStatus", options)

/**
 *
 * GET /api/v0/course-material/code-giveaways/:id/status - Returns information about a code giveaway.
 */
export const getCodeGiveawayStatusOptions = (options: Options<GetCodeGiveawayStatusData>) =>
  queryOptions<
    GetCodeGiveawayStatusResponse,
    DefaultError,
    GetCodeGiveawayStatusResponse,
    ReturnType<typeof getCodeGiveawayStatusQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCodeGiveawayStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCodeGiveawayStatusQueryKey(options),
  })

export const getCourseMaterialBackgroundQuestionsAndAnswersQueryKey = (
  options: Options<GetCourseMaterialBackgroundQuestionsAndAnswersData>,
) => createQueryKey("getCourseMaterialBackgroundQuestionsAndAnswers", options)

/**
 *
 * GET /api/v0/course-material/course-instance/:course_instance_id/background-questions-and-answers - Gets background questions and answers for an course instance.
 */
export const getCourseMaterialBackgroundQuestionsAndAnswersOptions = (
  options: Options<GetCourseMaterialBackgroundQuestionsAndAnswersData>,
) =>
  queryOptions<
    GetCourseMaterialBackgroundQuestionsAndAnswersResponse,
    DefaultError,
    GetCourseMaterialBackgroundQuestionsAndAnswersResponse,
    ReturnType<typeof getCourseMaterialBackgroundQuestionsAndAnswersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialBackgroundQuestionsAndAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialBackgroundQuestionsAndAnswersQueryKey(options),
  })

export const getCourseMaterialChapterExerciseProgressQueryKey = (
  options: Options<GetCourseMaterialChapterExerciseProgressData>,
) => createQueryKey("getCourseMaterialChapterExerciseProgress", options)

/**
 *
 * GET /api/v0/course-material/course-instance/:course_instance_id/chapters/:chapter_id/exercises/progress - Returns user progress for an exercise in given course instance.
 */
export const getCourseMaterialChapterExerciseProgressOptions = (
  options: Options<GetCourseMaterialChapterExerciseProgressData>,
) =>
  queryOptions<
    GetCourseMaterialChapterExerciseProgressResponse,
    DefaultError,
    GetCourseMaterialChapterExerciseProgressResponse,
    ReturnType<typeof getCourseMaterialChapterExerciseProgressQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterExerciseProgress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterExerciseProgressQueryKey(options),
  })

export const getCourseMaterialChapterProgressQueryKey = (
  options: Options<GetCourseMaterialChapterProgressData>,
) => createQueryKey("getCourseMaterialChapterProgress", options)

/**
 *
 * GET `/api/v0/course-material/course-instance/:course_instance_id/chapters/:chapter_id/progress - Returns user progress for chapter in course instance.
 */
export const getCourseMaterialChapterProgressOptions = (
  options: Options<GetCourseMaterialChapterProgressData>,
) =>
  queryOptions<
    GetCourseMaterialChapterProgressResponse,
    DefaultError,
    GetCourseMaterialChapterProgressResponse,
    ReturnType<typeof getCourseMaterialChapterProgressQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterProgress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterProgressQueryKey(options),
  })

export const getCourseMaterialCourseModuleCompletionsForUserQueryKey = (
  options: Options<GetCourseMaterialCourseModuleCompletionsForUserData>,
) => createQueryKey("getCourseMaterialCourseModuleCompletionsForUser", options)

/**
 *
 * GET /course-instances/:id/course-module-completions/:user_id - Returns a list of all course module completions for a given user for this course instance.
 */
export const getCourseMaterialCourseModuleCompletionsForUserOptions = (
  options: Options<GetCourseMaterialCourseModuleCompletionsForUserData>,
) =>
  queryOptions<
    GetCourseMaterialCourseModuleCompletionsForUserResponse,
    DefaultError,
    GetCourseMaterialCourseModuleCompletionsForUserResponse,
    ReturnType<typeof getCourseMaterialCourseModuleCompletionsForUserQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCourseModuleCompletionsForUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCourseModuleCompletionsForUserQueryKey(options),
  })

export const getCourseMaterialCourseModulePointsBreakdownQueryKey = (
  options: Options<GetCourseMaterialCourseModulePointsBreakdownData>,
) => createQueryKey("getCourseMaterialCourseModulePointsBreakdown", options)

/**
 *
 * GET `/api/v0/course-material/course-instances/:course_instance_id/course-modules/:course_module_id/points-breakdown` - Returns the user's points in the module's opened chapters, exercise by exercise.
 */
export const getCourseMaterialCourseModulePointsBreakdownOptions = (
  options: Options<GetCourseMaterialCourseModulePointsBreakdownData>,
) =>
  queryOptions<
    GetCourseMaterialCourseModulePointsBreakdownResponse,
    DefaultError,
    GetCourseMaterialCourseModulePointsBreakdownResponse,
    ReturnType<typeof getCourseMaterialCourseModulePointsBreakdownQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCourseModulePointsBreakdown({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCourseModulePointsBreakdownQueryKey(options),
  })

export const getCourseMaterialUserModuleCompletionsQueryKey = (
  options: Options<GetCourseMaterialUserModuleCompletionsData>,
) => createQueryKey("getCourseMaterialUserModuleCompletions", options)

/**
 *
 * GET `/api/v0/course-material/course-instance/{course_instance_id}/module-completions`
 */
export const getCourseMaterialUserModuleCompletionsOptions = (
  options: Options<GetCourseMaterialUserModuleCompletionsData>,
) =>
  queryOptions<
    GetCourseMaterialUserModuleCompletionsResponse,
    DefaultError,
    GetCourseMaterialUserModuleCompletionsResponse,
    ReturnType<typeof getCourseMaterialUserModuleCompletionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialUserModuleCompletions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialUserModuleCompletionsQueryKey(options),
  })

export const getCourseMaterialUserCourseProgressQueryKey = (
  options: Options<GetCourseMaterialUserCourseProgressData>,
) => createQueryKey("getCourseMaterialUserCourseProgress", options)

/**
 *
 * GET /api/v0/course-material/course-instance/:course_intance_id/progress - returns user progress information.
 */
export const getCourseMaterialUserCourseProgressOptions = (
  options: Options<GetCourseMaterialUserCourseProgressData>,
) =>
  queryOptions<
    GetCourseMaterialUserCourseProgressResponse,
    DefaultError,
    GetCourseMaterialUserCourseProgressResponse,
    ReturnType<typeof getCourseMaterialUserCourseProgressQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialUserCourseProgress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialUserCourseProgressQueryKey(options),
  })

/**
 *
 * POST /api/v0/course-material/course-instance/:course_instance_id/save-course-settings - enrolls user to the course instance and save background questions.
 */
export const saveCourseMaterialCourseSettingsMutation = (
  options?: Partial<Options<SaveCourseMaterialCourseSettingsData>>,
): UseMutationOptions<
  SaveCourseMaterialCourseSettingsResponse,
  DefaultError,
  Options<SaveCourseMaterialCourseSettingsData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveCourseMaterialCourseSettingsResponse,
    DefaultError,
    Options<SaveCourseMaterialCourseSettingsData>
  > = {
    mutationFn: async (fnOptions) =>
      await saveCourseMaterialCourseSettings({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialModuleIdByChapterIdQueryKey = (
  options: Options<GetCourseMaterialModuleIdByChapterIdData>,
) => createQueryKey("getCourseMaterialModuleIdByChapterId", options)

/**
 *
 * GET `/api/v0/course-material/course-modules/chapter/:chapter_id`
 *
 * Returns course module id based on chapter.
 */
export const getCourseMaterialModuleIdByChapterIdOptions = (
  options: Options<GetCourseMaterialModuleIdByChapterIdData>,
) =>
  queryOptions<
    GetCourseMaterialModuleIdByChapterIdResponse,
    DefaultError,
    GetCourseMaterialModuleIdByChapterIdResponse,
    ReturnType<typeof getCourseMaterialModuleIdByChapterIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialModuleIdByChapterId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialModuleIdByChapterIdQueryKey(options),
  })

export const getCourseMaterialDefaultModuleIdByCourseIdQueryKey = (
  options: Options<GetCourseMaterialDefaultModuleIdByCourseIdData>,
) => createQueryKey("getCourseMaterialDefaultModuleIdByCourseId", options)

/**
 *
 * GET `/api/v0/course-material/course-modules/course/:course_instance_id`
 *
 * Returns course module id based on chapter.
 */
export const getCourseMaterialDefaultModuleIdByCourseIdOptions = (
  options: Options<GetCourseMaterialDefaultModuleIdByCourseIdData>,
) =>
  queryOptions<
    GetCourseMaterialDefaultModuleIdByCourseIdResponse,
    DefaultError,
    GetCourseMaterialDefaultModuleIdByCourseIdResponse,
    ReturnType<typeof getCourseMaterialDefaultModuleIdByCourseIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialDefaultModuleIdByCourseId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialDefaultModuleIdByCourseIdQueryKey(options),
  })

export const getCourseMaterialExerciseTasksByModuleAndTypeQueryKey = (
  options: Options<GetCourseMaterialExerciseTasksByModuleAndTypeData>,
) => createQueryKey("getCourseMaterialExerciseTasksByModuleAndType", options)

/**
 *
 * GET `/api/v0/course-material/course-modules/:course_module_id/exercise-tasks/:exercise_type/:course_instance_id`
 *
 * Returns exercise submissions for user to be used in en exercise service Custom view.
 */
export const getCourseMaterialExerciseTasksByModuleAndTypeOptions = (
  options: Options<GetCourseMaterialExerciseTasksByModuleAndTypeData>,
) =>
  queryOptions<
    GetCourseMaterialExerciseTasksByModuleAndTypeResponse,
    DefaultError,
    GetCourseMaterialExerciseTasksByModuleAndTypeResponse,
    ReturnType<typeof getCourseMaterialExerciseTasksByModuleAndTypeQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialExerciseTasksByModuleAndType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialExerciseTasksByModuleAndTypeQueryKey(options),
  })

export const getCourseMaterialCourseQueryKey = (options: Options<GetCourseMaterialCourseData>) =>
  createQueryKey("getCourseMaterialCourse", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id` - Get course.
 */
export const getCourseMaterialCourseOptions = (options: Options<GetCourseMaterialCourseData>) =>
  queryOptions<
    GetCourseMaterialCourseResponse,
    DefaultError,
    GetCourseMaterialCourseResponse,
    ReturnType<typeof getCourseMaterialCourseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCourseQueryKey(options),
  })

export const getAiUsageNoticeAcknowledgementQueryKey = (
  options: Options<GetAiUsageNoticeAcknowledgementData>,
) => createQueryKey("getAiUsageNoticeAcknowledgement", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/ai-usage-notice-acknowledgement` - Whether the
 * current user has acknowledged the AI-usage / academic-integrity notice for this course.
 */
export const getAiUsageNoticeAcknowledgementOptions = (
  options: Options<GetAiUsageNoticeAcknowledgementData>,
) =>
  queryOptions<
    GetAiUsageNoticeAcknowledgementResponse,
    DefaultError,
    GetAiUsageNoticeAcknowledgementResponse,
    ReturnType<typeof getAiUsageNoticeAcknowledgementQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getAiUsageNoticeAcknowledgement({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getAiUsageNoticeAcknowledgementQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/ai-usage-notice-acknowledgement` - Records that
 * the current user has acknowledged the AI-usage / academic-integrity notice for this course.
 */
export const acknowledgeAiUsageNoticeMutation = (
  options?: Partial<Options<AcknowledgeAiUsageNoticeData>>,
): UseMutationOptions<
  AcknowledgeAiUsageNoticeResponse,
  DefaultError,
  Options<AcknowledgeAiUsageNoticeData>
> => {
  const mutationOptions: UseMutationOptions<
    AcknowledgeAiUsageNoticeResponse,
    DefaultError,
    Options<AcknowledgeAiUsageNoticeData>
  > = {
    mutationFn: async (fnOptions) =>
      await acknowledgeAiUsageNotice({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialChaptersQueryKey = (
  options: Options<GetCourseMaterialChaptersData>,
) => createQueryKey("getCourseMaterialChapters", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/chapters` - Returns a list of chapters in a course.
 */
export const getCourseMaterialChaptersOptions = (options: Options<GetCourseMaterialChaptersData>) =>
  queryOptions<
    GetCourseMaterialChaptersResponse,
    DefaultError,
    GetCourseMaterialChaptersResponse,
    ReturnType<typeof getCourseMaterialChaptersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChaptersQueryKey(options),
  })

export const getCourseMaterialCourseInstancesQueryKey = (
  options: Options<GetCourseMaterialCourseInstancesData>,
) => createQueryKey("getCourseMaterialCourseInstances", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/course-instances` - Returns all course instances for given course id.
 */
export const getCourseMaterialCourseInstancesOptions = (
  options: Options<GetCourseMaterialCourseInstancesData>,
) =>
  queryOptions<
    GetCourseMaterialCourseInstancesResponse,
    DefaultError,
    GetCourseMaterialCourseInstancesResponse,
    ReturnType<typeof getCourseMaterialCourseInstancesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCourseInstances({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCourseInstancesQueryKey(options),
  })

export const getCourseMaterialStudentCountriesQueryKey = (
  options: Options<GetCourseMaterialStudentCountriesData>,
) => createQueryKey("getCourseMaterialStudentCountries", options)

/**
 *
 * GET `/api/v0/{course_id}/course-instances/{course_instance_id}/student-countries - Returns countries of student registered in a course.
 */
export const getCourseMaterialStudentCountriesOptions = (
  options: Options<GetCourseMaterialStudentCountriesData>,
) =>
  queryOptions<
    GetCourseMaterialStudentCountriesResponse,
    DefaultError,
    GetCourseMaterialStudentCountriesResponse,
    ReturnType<typeof getCourseMaterialStudentCountriesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialStudentCountries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialStudentCountriesQueryKey(options),
  })

/**
 *
 * POST `/api/v0/{course_id}/course-instances/{course_instance_id}/student-countries/{country_code}` - Add a new student's country entry.
 */
export const postCourseMaterialStudentCountryMutation = (
  options?: Partial<Options<PostCourseMaterialStudentCountryData>>,
): UseMutationOptions<
  PostCourseMaterialStudentCountryResponse,
  DefaultError,
  Options<PostCourseMaterialStudentCountryData>
> => {
  const mutationOptions: UseMutationOptions<
    PostCourseMaterialStudentCountryResponse,
    DefaultError,
    Options<PostCourseMaterialStudentCountryData>
  > = {
    mutationFn: async (fnOptions) =>
      await postCourseMaterialStudentCountry({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCurrentCourseMaterialCourseInstanceQueryKey = (
  options: Options<GetCurrentCourseMaterialCourseInstanceData>,
) => createQueryKey("getCurrentCourseMaterialCourseInstance", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/current-instance` - Returns the instance of a course for the current user, if there is one.
 */
export const getCurrentCourseMaterialCourseInstanceOptions = (
  options: Options<GetCurrentCourseMaterialCourseInstanceData>,
) =>
  queryOptions<
    GetCurrentCourseMaterialCourseInstanceResponse,
    DefaultError,
    GetCurrentCourseMaterialCourseInstanceResponse,
    ReturnType<typeof getCurrentCourseMaterialCourseInstanceQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCurrentCourseMaterialCourseInstance({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCurrentCourseMaterialCourseInstanceQueryKey(options),
  })

export const getCourseMaterialCustomPrivacyPolicyCheckboxTextsQueryKey = (
  options: Options<GetCourseMaterialCustomPrivacyPolicyCheckboxTextsData>,
) => createQueryKey("getCourseMaterialCustomPrivacyPolicyCheckboxTexts", options)

/**
 *
 * GET /courses/:course_id/custom-privacy-policy-checkbox-texts - Used to get customized checkbox texts for courses that use a different privacy policy than all our other courses (e.g. the Elements of AI course). These texts are shown in the course settings dialog.
 */
export const getCourseMaterialCustomPrivacyPolicyCheckboxTextsOptions = (
  options: Options<GetCourseMaterialCustomPrivacyPolicyCheckboxTextsData>,
) =>
  queryOptions<
    GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponse,
    DefaultError,
    GetCourseMaterialCustomPrivacyPolicyCheckboxTextsResponse,
    ReturnType<typeof getCourseMaterialCustomPrivacyPolicyCheckboxTextsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCustomPrivacyPolicyCheckboxTexts({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCustomPrivacyPolicyCheckboxTextsQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/feedback` - Creates new feedback.
 */
export const postFeedbackMutation = (
  options?: Partial<Options<PostFeedbackData>>,
): UseMutationOptions<PostFeedbackResponse, DefaultError, Options<PostFeedbackData>> => {
  const mutationOptions: UseMutationOptions<
    PostFeedbackResponse,
    DefaultError,
    Options<PostFeedbackData>
  > = {
    mutationFn: async (fnOptions) =>
      await postFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialUserMarketingConsentQueryKey = (
  options: Options<GetCourseMaterialUserMarketingConsentData>,
) => createQueryKey("getCourseMaterialUserMarketingConsent", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/fetch-user-marketing-consent`
 */
export const getCourseMaterialUserMarketingConsentOptions = (
  options: Options<GetCourseMaterialUserMarketingConsentData>,
) =>
  queryOptions<
    GetCourseMaterialUserMarketingConsentResponse,
    DefaultError,
    GetCourseMaterialUserMarketingConsentResponse,
    ReturnType<typeof getCourseMaterialUserMarketingConsentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialUserMarketingConsent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialUserMarketingConsentQueryKey(options),
  })

export const getCourseMaterialGlossaryQueryKey = (
  options: Options<GetCourseMaterialGlossaryData>,
) => createQueryKey("getCourseMaterialGlossary", options)

export const getCourseMaterialGlossaryOptions = (options: Options<GetCourseMaterialGlossaryData>) =>
  queryOptions<
    GetCourseMaterialGlossaryResponse,
    DefaultError,
    GetCourseMaterialGlossaryResponse,
    ReturnType<typeof getCourseMaterialGlossaryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialGlossary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialGlossaryQueryKey(options),
  })

export const getCourseMaterialLanguageVersionNavigationInfosQueryKey = (
  options: Options<GetCourseMaterialLanguageVersionNavigationInfosData>,
) => createQueryKey("getCourseMaterialLanguageVersionNavigationInfos", options)

/**
 *
 * GET `/api/v0/course-material/courses/:id/language-versions-navigation-info/from-page/:page_id` - Returns all language versions of the same course. Since this is for course material, this does not include draft courses. To make developing new courses easier, we include all draft courses that the user has access to.
 */
export const getCourseMaterialLanguageVersionNavigationInfosOptions = (
  options: Options<GetCourseMaterialLanguageVersionNavigationInfosData>,
) =>
  queryOptions<
    GetCourseMaterialLanguageVersionNavigationInfosResponse,
    DefaultError,
    GetCourseMaterialLanguageVersionNavigationInfosResponse,
    ReturnType<typeof getCourseMaterialLanguageVersionNavigationInfosQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialLanguageVersionNavigationInfos({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialLanguageVersionNavigationInfosQueryKey(options),
  })

export const getCourseMaterialCoursePagesQueryKey = (
  options: Options<GetCourseMaterialCoursePagesData>,
) => createQueryKey("getCourseMaterialCoursePages", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/pages` - Returns a list of public pages on a course.
 *
 * Since anyone can access this endpoint, any unlisted pages are omited from these results.
 */
export const getCourseMaterialCoursePagesOptions = (
  options: Options<GetCourseMaterialCoursePagesData>,
) =>
  queryOptions<
    GetCourseMaterialCoursePagesResponse,
    DefaultError,
    GetCourseMaterialCoursePagesResponse,
    ReturnType<typeof getCourseMaterialCoursePagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCoursePages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCoursePagesQueryKey(options),
  })

export const getCourseMaterialPageByCourseIdAndLanguageGroupIdQueryKey = (
  options: Options<GetCourseMaterialPageByCourseIdAndLanguageGroupIdData>,
) => createQueryKey("getCourseMaterialPageByCourseIdAndLanguageGroupId", options)

/**
 *
 * GET `/api/v0/{course_id}/pages/by-language-group-id/{page_language_group_id} - Returns a page with the given course id and language group id.
 */
export const getCourseMaterialPageByCourseIdAndLanguageGroupIdOptions = (
  options: Options<GetCourseMaterialPageByCourseIdAndLanguageGroupIdData>,
) =>
  queryOptions<
    GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponse,
    DefaultError,
    GetCourseMaterialPageByCourseIdAndLanguageGroupIdResponse,
    ReturnType<typeof getCourseMaterialPageByCourseIdAndLanguageGroupIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageByCourseIdAndLanguageGroupId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageByCourseIdAndLanguageGroupIdQueryKey(options),
  })

export const getCourseMaterialPartnersBlockQueryKey = (
  options: Options<GetCourseMaterialPartnersBlockData>,
) => createQueryKey("getCourseMaterialPartnersBlock", options)

/**
 *
 * GET /courses/:course_id/partners-block - Gets a partners block related to a course
 */
export const getCourseMaterialPartnersBlockOptions = (
  options: Options<GetCourseMaterialPartnersBlockData>,
) =>
  queryOptions<
    GetCourseMaterialPartnersBlockResponse,
    DefaultError,
    GetCourseMaterialPartnersBlockResponse,
    ReturnType<typeof getCourseMaterialPartnersBlockQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPartnersBlock({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPartnersBlockQueryKey(options),
  })

export const getCourseMaterialPrivacyLinkQueryKey = (
  options: Options<GetCourseMaterialPrivacyLinkData>,
) => createQueryKey("getCourseMaterialPrivacyLink", options)

/**
 *
 * GET /courses/:course_id/privacy_link - Gets a privacy link related to a course
 */
export const getCourseMaterialPrivacyLinkOptions = (
  options: Options<GetCourseMaterialPrivacyLinkData>,
) =>
  queryOptions<
    GetCourseMaterialPrivacyLinkResponse,
    DefaultError,
    GetCourseMaterialPrivacyLinkResponse,
    ReturnType<typeof getCourseMaterialPrivacyLinkQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPrivacyLink({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPrivacyLinkQueryKey(options),
  })

export const getCourseMaterialReferencesQueryKey = (
  options: Options<GetCourseMaterialReferencesData>,
) => createQueryKey("getCourseMaterialReferences", options)

export const getCourseMaterialReferencesOptions = (
  options: Options<GetCourseMaterialReferencesData>,
) =>
  queryOptions<
    GetCourseMaterialReferencesResponse,
    DefaultError,
    GetCourseMaterialReferencesResponse,
    ReturnType<typeof getCourseMaterialReferencesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialReferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialReferencesQueryKey(options),
  })

export const getCourseMaterialResearchConsentFormQueryKey = (
  options: Options<GetCourseMaterialResearchConsentFormData>,
) => createQueryKey("getCourseMaterialResearchConsentForm", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/research-consent-form` - Fetches courses research form with course id.
 */
export const getCourseMaterialResearchConsentFormOptions = (
  options: Options<GetCourseMaterialResearchConsentFormData>,
) =>
  queryOptions<
    GetCourseMaterialResearchConsentFormResponse,
    DefaultError,
    GetCourseMaterialResearchConsentFormResponse,
    ReturnType<typeof getCourseMaterialResearchConsentFormQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialResearchConsentForm({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialResearchConsentFormQueryKey(options),
  })

export const getCourseMaterialResearchConsentFormQuestionsQueryKey = (
  options: Options<GetCourseMaterialResearchConsentFormQuestionsData>,
) => createQueryKey("getCourseMaterialResearchConsentFormQuestions", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/research-consent-form-questions` - Fetches courses research form questions with course id.
 */
export const getCourseMaterialResearchConsentFormQuestionsOptions = (
  options: Options<GetCourseMaterialResearchConsentFormQuestionsData>,
) =>
  queryOptions<
    GetCourseMaterialResearchConsentFormQuestionsResponse,
    DefaultError,
    GetCourseMaterialResearchConsentFormQuestionsResponse,
    ReturnType<typeof getCourseMaterialResearchConsentFormQuestionsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialResearchConsentFormQuestions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialResearchConsentFormQuestionsQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/research-consent-form-questions-answer` - Upserts users consent for a courses research form question.
 */
export const postCourseMaterialResearchConsentFormAnswerMutation = (
  options?: Partial<Options<PostCourseMaterialResearchConsentFormAnswerData>>,
): UseMutationOptions<
  PostCourseMaterialResearchConsentFormAnswerResponse,
  DefaultError,
  Options<PostCourseMaterialResearchConsentFormAnswerData>
> => {
  const mutationOptions: UseMutationOptions<
    PostCourseMaterialResearchConsentFormAnswerResponse,
    DefaultError,
    Options<PostCourseMaterialResearchConsentFormAnswerData>
  > = {
    mutationFn: async (fnOptions) =>
      await postCourseMaterialResearchConsentFormAnswer({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialResearchConsentFormAnswersQueryKey = (
  options: Options<GetCourseMaterialResearchConsentFormAnswersData>,
) => createQueryKey("getCourseMaterialResearchConsentFormAnswers", options)

/**
 *
 * GET `/api/v0/course/courses/:course_id/research-consent-form-users-answers` - Fetches users answers for courses research form.
 */
export const getCourseMaterialResearchConsentFormAnswersOptions = (
  options: Options<GetCourseMaterialResearchConsentFormAnswersData>,
) =>
  queryOptions<
    GetCourseMaterialResearchConsentFormAnswersResponse,
    DefaultError,
    GetCourseMaterialResearchConsentFormAnswersResponse,
    ReturnType<typeof getCourseMaterialResearchConsentFormAnswersQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialResearchConsentFormAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialResearchConsentFormAnswersQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/search-pages-with-phrase` - Returns a list of pages given a search query.
 *
 * Provided words are supposed to appear right after each other in the source document.
 *
 * # Example
 *
 * Request:
 *
 * ```http
 * POST /api/v0/course-material/courses/1a68e8b0-d151-4c0e-9307-bb154e9d2be1/search-pages-with-phrase HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "query": "Everything"
 * }
 * ```
 */
export const searchPagesWithPhraseMutation = (
  options?: Partial<Options<SearchPagesWithPhraseData>>,
): UseMutationOptions<
  SearchPagesWithPhraseResponse,
  DefaultError,
  Options<SearchPagesWithPhraseData>
> => {
  const mutationOptions: UseMutationOptions<
    SearchPagesWithPhraseResponse,
    DefaultError,
    Options<SearchPagesWithPhraseData>
  > = {
    mutationFn: async (fnOptions) =>
      await searchPagesWithPhrase({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/search-pages-with-words` - Returns a list of pages given a search query.
 *
 * Provided words can appear in any order in the source document.
 *
 * # Example
 *
 * Request:
 *
 * ```http
 * POST /api/v0/course-material/courses/1a68e8b0-d151-4c0e-9307-bb154e9d2be1/search-pages-with-words HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "query": "Everything"
 * }
 * ```
 */
export const searchPagesWithWordsMutation = (
  options?: Partial<Options<SearchPagesWithWordsData>>,
): UseMutationOptions<
  SearchPagesWithWordsResponse,
  DefaultError,
  Options<SearchPagesWithWordsData>
> => {
  const mutationOptions: UseMutationOptions<
    SearchPagesWithWordsResponse,
    DefaultError,
    Options<SearchPagesWithWordsData>
  > = {
    mutationFn: async (fnOptions) =>
      await searchPagesWithWords({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialTopLevelPagesQueryKey = (
  options: Options<GetCourseMaterialTopLevelPagesData>,
) => createQueryKey("getCourseMaterialTopLevelPages", options)

/**
 *
 * GET /api/v0/course-material/courses/:course_id/top-level-pages
 */
export const getCourseMaterialTopLevelPagesOptions = (
  options: Options<GetCourseMaterialTopLevelPagesData>,
) =>
  queryOptions<
    GetCourseMaterialTopLevelPagesResponse,
    DefaultError,
    GetCourseMaterialTopLevelPagesResponse,
    ReturnType<typeof getCourseMaterialTopLevelPagesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialTopLevelPages({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialTopLevelPagesQueryKey(options),
  })

export const getCourseMaterialUserChapterLocksQueryKey = (
  options: Options<GetCourseMaterialUserChapterLocksData>,
) => createQueryKey("getCourseMaterialUserChapterLocks", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/user-chapter-locks` - Get user's chapter locking statuses for course
 *
 * Returns all chapters that the authenticated user has unlocked or completed for the specified course.
 * *
 */
export const getCourseMaterialUserChapterLocksOptions = (
  options: Options<GetCourseMaterialUserChapterLocksData>,
) =>
  queryOptions<
    GetCourseMaterialUserChapterLocksResponse,
    DefaultError,
    GetCourseMaterialUserChapterLocksResponse,
    ReturnType<typeof getCourseMaterialUserChapterLocksQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialUserChapterLocks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialUserChapterLocksQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_id/user-marketing-consent` - Adds or updates user's marketing consent for a specific course.
 */
export const updateMarketingConsentMutation = (
  options?: Partial<Options<UpdateMarketingConsentData>>,
): UseMutationOptions<
  UpdateMarketingConsentResponse,
  DefaultError,
  Options<UpdateMarketingConsentData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateMarketingConsentResponse,
    DefaultError,
    Options<UpdateMarketingConsentData>
  > = {
    mutationFn: async (fnOptions) =>
      await updateMarketingConsent({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialUserCourseSettingsQueryKey = (
  options: Options<GetCourseMaterialUserCourseSettingsData>,
) => createQueryKey("getCourseMaterialUserCourseSettings", options)

/**
 *
 * GET `/api/v0/course-material/courses/:course_id/user-settings` - Returns user settings for the current course.
 */
export const getCourseMaterialUserCourseSettingsOptions = (
  options: Options<GetCourseMaterialUserCourseSettingsData>,
) =>
  queryOptions<
    GetCourseMaterialUserCourseSettingsResponse,
    DefaultError,
    GetCourseMaterialUserCourseSettingsResponse,
    ReturnType<typeof getCourseMaterialUserCourseSettingsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialUserCourseSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialUserCourseSettingsQueryKey(options),
  })

export const getCourseMaterialStudentCountryQueryKey = (
  options: Options<GetCourseMaterialStudentCountryData>,
) => createQueryKey("getCourseMaterialStudentCountry", options)

/**
 *
 * GET `/api/v0/{course_id}/student-country - Returns country of a student registered in a course.
 */
export const getCourseMaterialStudentCountryOptions = (
  options: Options<GetCourseMaterialStudentCountryData>,
) =>
  queryOptions<
    GetCourseMaterialStudentCountryResponse,
    DefaultError,
    GetCourseMaterialStudentCountryResponse,
    ReturnType<typeof getCourseMaterialStudentCountryQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialStudentCountry({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialStudentCountryQueryKey(options),
  })

export const getCourseMaterialCoursePageByPathQueryKey = (
  options: Options<GetCourseMaterialCoursePageByPathData>,
) => createQueryKey("getCourseMaterialCoursePageByPath", options)

/**
 *
 * GET `/:course_slug/page-by-path/...` - Returns a course page by path
 *
 * If the page has moved and there's a redirection, this will still return the moved page but the field `was_redirected` will indicate that the redirection happened. The new path can be found in the page object. The frontend is supposed to update the url of the page to the new location without reloading the page.
 *
 * # Example
 * GET /api/v0/course-material/courses/introduction-to-everything/page-by-path//part-2/hello-world
 */
export const getCourseMaterialCoursePageByPathOptions = (
  options: Options<GetCourseMaterialCoursePageByPathData>,
) =>
  queryOptions<
    GetCourseMaterialCoursePageByPathResponse,
    DefaultError,
    GetCourseMaterialCoursePageByPathResponse,
    ReturnType<typeof getCourseMaterialCoursePageByPathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCoursePageByPath({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCoursePageByPathQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/courses/:course_slug/edit` - Creates a new edit proposal.
 */
export const postCourseMaterialCourseEditProposalMutation = (
  options?: Partial<Options<PostCourseMaterialCourseEditProposalData>>,
): UseMutationOptions<
  PostCourseMaterialCourseEditProposalResponse,
  DefaultError,
  Options<PostCourseMaterialCourseEditProposalData>
> => {
  const mutationOptions: UseMutationOptions<
    PostCourseMaterialCourseEditProposalResponse,
    DefaultError,
    Options<PostCourseMaterialCourseEditProposalData>
  > = {
    mutationFn: async (fnOptions) =>
      await postCourseMaterialCourseEditProposal({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const fetchExamForTestingQueryKey = (options: Options<FetchExamForTestingData>) =>
  createQueryKey("fetchExamForTesting", options)

/**
 *
 * GET /api/v0/course-material/exams/:id/fetch-exam-for-testing
 *
 * Fetches an exam for testing.
 */
export const fetchExamForTestingOptions = (options: Options<FetchExamForTestingData>) =>
  queryOptions<
    FetchExamForTestingResponse,
    DefaultError,
    FetchExamForTestingResponse,
    ReturnType<typeof fetchExamForTestingQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await fetchExamForTesting({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: fetchExamForTestingQueryKey(options),
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/reset-exam-progress
 *
 * Used for testing an exam, resets exercise submissions and restarts the exam time.
 */
export const resetExamProgressMutation = (
  options?: Partial<Options<ResetExamProgressData>>,
): UseMutationOptions<unknown, DefaultError, Options<ResetExamProgressData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<ResetExamProgressData>
  > = {
    mutationFn: async (fnOptions) =>
      await resetExamProgress({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST /api/v0/course-material/exams/:id/update-show-exercise-answers
 *
 * Used for testing an exam, updates wheter exercise answers are shown.
 */
export const updateShowExerciseAnswersMutation = (
  options?: Partial<Options<UpdateShowExerciseAnswersData>>,
): UseMutationOptions<unknown, DefaultError, Options<UpdateShowExerciseAnswersData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateShowExerciseAnswersData>
  > = {
    mutationFn: async (fnOptions) =>
      await updateShowExerciseAnswers({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const fetchExamQueryKey = (options: Options<FetchExamData>) =>
  createQueryKey("fetchExam", options)

/**
 *
 * GET /api/v0/course-material/exams/:id
 */
export const fetchExamOptions = (options: Options<FetchExamData>) =>
  queryOptions<
    FetchExamResponse,
    DefaultError,
    FetchExamResponse,
    ReturnType<typeof fetchExamQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await fetchExam({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: fetchExamQueryKey(options),
  })

/**
 *
 * POST /api/v0/course-material/exams/:id/end-exam-time
 *
 * Used for marking the students exam as ended in the exam enrollment
 */
export const endExamTimeMutation = (
  options?: Partial<Options<EndExamTimeData>>,
): UseMutationOptions<unknown, DefaultError, Options<EndExamTimeData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EndExamTimeData>> = {
    mutationFn: async (fnOptions) =>
      await endExamTime({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST /api/v0/course-material/exams/:id/enroll
 */
export const enrollInExamMutation = (
  options?: Partial<Options<EnrollInExamData>>,
): UseMutationOptions<unknown, DefaultError, Options<EnrollInExamData>> => {
  const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<EnrollInExamData>> = {
    mutationFn: async (fnOptions) =>
      await enrollInExam({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const fetchExamEnrollmentQueryKey = (options: Options<FetchExamEnrollmentData>) =>
  createQueryKey("fetchExamEnrollment", options)

/**
 *
 * GET /api/v0/course-material/exams/:id/enrollment
 */
export const fetchExamEnrollmentOptions = (options: Options<FetchExamEnrollmentData>) =>
  queryOptions<
    FetchExamEnrollmentResponse,
    DefaultError,
    FetchExamEnrollmentResponse,
    ReturnType<typeof fetchExamEnrollmentQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await fetchExamEnrollment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: fetchExamEnrollmentQueryKey(options),
  })

export const getCourseMaterialExerciseQueryKey = (
  options: Options<GetCourseMaterialExerciseData>,
) => createQueryKey("getCourseMaterialExercise", options)

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id` - Get exercise by id. Includes
 * relevant context so that doing the exercise is possible based on the response.
 *
 * This endpoint does not expose exercise's private spec because it would
 * expose the correct answers to the user.
 */
export const getCourseMaterialExerciseOptions = (options: Options<GetCourseMaterialExerciseData>) =>
  queryOptions<
    GetCourseMaterialExerciseResponse,
    DefaultError,
    GetCourseMaterialExerciseResponse,
    ReturnType<typeof getCourseMaterialExerciseQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialExercise({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialExerciseQueryKey(options),
  })

export const fetchPeerReviewDataReceivedByExerciseIdQueryKey = (
  options: Options<FetchPeerReviewDataReceivedByExerciseIdData>,
) => createQueryKey("fetchPeerReviewDataReceivedByExerciseId", options)

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id/peer-review-received` - Get peer review recieved from other student for an exercise. This includes peer review submitted and the question asociated with it.
 */
export const fetchPeerReviewDataReceivedByExerciseIdOptions = (
  options: Options<FetchPeerReviewDataReceivedByExerciseIdData>,
) =>
  queryOptions<
    FetchPeerReviewDataReceivedByExerciseIdResponse,
    DefaultError,
    FetchPeerReviewDataReceivedByExerciseIdResponse,
    ReturnType<typeof fetchPeerReviewDataReceivedByExerciseIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await fetchPeerReviewDataReceivedByExerciseId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: fetchPeerReviewDataReceivedByExerciseIdQueryKey(options),
  })

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/flag-peer-review-answer - Post a report of an answer in peer review made by a student
 */
export const postFlagAnswerInPeerReviewMutation = (
  options?: Partial<Options<PostFlagAnswerInPeerReviewData>>,
): UseMutationOptions<
  PostFlagAnswerInPeerReviewResponse,
  DefaultError,
  Options<PostFlagAnswerInPeerReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    PostFlagAnswerInPeerReviewResponse,
    DefaultError,
    Options<PostFlagAnswerInPeerReviewData>
  > = {
    mutationFn: async (fnOptions) =>
      await postFlagAnswerInPeerReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/peer-or-self-reviews - Post a peer review or a self review for an
 * * exercise submission.
 */
export const postPeerOrSelfReviewSubmissionMutation = (
  options?: Partial<Options<PostPeerOrSelfReviewSubmissionData>>,
): UseMutationOptions<
  PostPeerOrSelfReviewSubmissionResponse,
  DefaultError,
  Options<PostPeerOrSelfReviewSubmissionData>
> => {
  const mutationOptions: UseMutationOptions<
    PostPeerOrSelfReviewSubmissionResponse,
    DefaultError,
    Options<PostPeerOrSelfReviewSubmissionData>
  > = {
    mutationFn: async (fnOptions) =>
      await postPeerOrSelfReviewSubmission({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * * POST `/api/v0/course-material/exercises/:exercise_id/peer-or-self-reviews/start` - Post a signal indicating that
 * * the user will start the peer or self reviewing process.
 * *
 * * This operation is only valid for exercises marked for peer reviews. No further submissions will be
 * * accepted after posting to this endpoint.
 */
export const postStartPeerOrSelfReviewMutation = (
  options?: Partial<Options<PostStartPeerOrSelfReviewData>>,
): UseMutationOptions<
  PostStartPeerOrSelfReviewResponse,
  DefaultError,
  Options<PostStartPeerOrSelfReviewData>
> => {
  const mutationOptions: UseMutationOptions<
    PostStartPeerOrSelfReviewResponse,
    DefaultError,
    Options<PostStartPeerOrSelfReviewData>
  > = {
    mutationFn: async (fnOptions) =>
      await postStartPeerOrSelfReview({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const fetchPeerOrSelfReviewDataByExerciseIdQueryKey = (
  options: Options<FetchPeerOrSelfReviewDataByExerciseIdData>,
) => createQueryKey("fetchPeerOrSelfReviewDataByExerciseId", options)

/**
 *
 * GET `/api/v0/course-material/exercises/:exercise_id/peer-review` - Get peer review for an exercise. This includes the submission to peer review and the questions the user is supposed to answer.ALTER
 *
 * This request will fail if the user is not in the peer review stage yet because the information included in the peer review often exposes the correct solution to the exercise.
 */
export const fetchPeerOrSelfReviewDataByExerciseIdOptions = (
  options: Options<FetchPeerOrSelfReviewDataByExerciseIdData>,
) =>
  queryOptions<
    FetchPeerOrSelfReviewDataByExerciseIdResponse,
    DefaultError,
    FetchPeerOrSelfReviewDataByExerciseIdResponse,
    ReturnType<typeof fetchPeerOrSelfReviewDataByExerciseIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await fetchPeerOrSelfReviewDataByExerciseId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: fetchPeerOrSelfReviewDataByExerciseIdQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/exercises/:exercise_id/submissions` - Post new submission for an
 * exercise.
 *
 * # Example
 * ```http
 * POST /api/v0/course-material/exercises/:exercise_id/submissions HTTP/1.1
 * Content-Type: application/json
 *
 * {
 * "exercise_slide_id": "0125c21b-6afa-4652-89f7-56c48bd8ffe4",
 * "exercise_task_answers": [
 * {
 * "exercise_task_id": "0125c21b-6afa-4652-89f7-56c48bd8ffe4",
 * "answer": {
 * "kind": "json",
 * "data": { "selectedOptionId": "8f09e9a0-ac20-486a-ba29-704e7eeaf6af" }
 * }
 * }
 * ]
 * }
 * ```
 */
export const postSubmissionMutation = (
  options?: Partial<Options<PostSubmissionData>>,
): UseMutationOptions<PostSubmissionResponse, DefaultError, Options<PostSubmissionData>> => {
  const mutationOptions: UseMutationOptions<
    PostSubmissionResponse,
    DefaultError,
    Options<PostSubmissionData>
  > = {
    mutationFn: async (fnOptions) =>
      await postSubmission({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialMentimeterOembedQueryKey = (
  options: Options<GetCourseMaterialMentimeterOembedData>,
) => createQueryKey("getCourseMaterialMentimeterOembed", options)

/**
 *
 * GET `/api/v0/course-material/oembed/mentimeter?url=https://menti.com/123qwerty`
 */
export const getCourseMaterialMentimeterOembedOptions = (
  options: Options<GetCourseMaterialMentimeterOembedData>,
) =>
  queryOptions<
    GetCourseMaterialMentimeterOembedResponse,
    DefaultError,
    GetCourseMaterialMentimeterOembedResponse,
    ReturnType<typeof getCourseMaterialMentimeterOembedQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialMentimeterOembed({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialMentimeterOembedQueryKey(options),
  })

export const getCourseMaterialOrganizationQueryKey = (
  options: Options<GetCourseMaterialOrganizationData>,
) => createQueryKey("getCourseMaterialOrganization", options)

/**
 *
 * GET /organizations/:organization_id - Get organization.
 */
export const getCourseMaterialOrganizationOptions = (
  options: Options<GetCourseMaterialOrganizationData>,
) =>
  queryOptions<
    GetCourseMaterialOrganizationResponse,
    DefaultError,
    GetCourseMaterialOrganizationResponse,
    ReturnType<typeof getCourseMaterialOrganizationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialOrganization({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialOrganizationQueryKey(options),
  })

export const getCourseMaterialPageAudioFilesQueryKey = (
  options: Options<GetCourseMaterialPageAudioFilesData>,
) => createQueryKey("getCourseMaterialPageAudioFiles", options)

export const getCourseMaterialPageAudioFilesOptions = (
  options: Options<GetCourseMaterialPageAudioFilesData>,
) =>
  queryOptions<
    GetCourseMaterialPageAudioFilesResponse,
    DefaultError,
    GetCourseMaterialPageAudioFilesResponse,
    ReturnType<typeof getCourseMaterialPageAudioFilesQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageAudioFiles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageAudioFilesQueryKey(options),
  })

export const getCourseMaterialPageByExamIdQueryKey = (
  options: Options<GetCourseMaterialPageByExamIdData>,
) => createQueryKey("getCourseMaterialPageByExamId", options)

/**
 *
 * GET /api/v0/course-material/pages/exam/{page_id}
 */
export const getCourseMaterialPageByExamIdOptions = (
  options: Options<GetCourseMaterialPageByExamIdData>,
) =>
  queryOptions<
    GetCourseMaterialPageByExamIdResponse,
    DefaultError,
    GetCourseMaterialPageByExamIdResponse,
    ReturnType<typeof getCourseMaterialPageByExamIdQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageByExamId({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageByExamIdQueryKey(options),
  })

export const getCourseMaterialPageChapterAndCourseInformationQueryKey = (
  options: Options<GetCourseMaterialPageChapterAndCourseInformationData>,
) => createQueryKey("getCourseMaterialPageChapterAndCourseInformation", options)

/**
 *
 * GET /api/v0/course-material/pages/:page_id/chapter-and-course-information - gives the page's chapter and course information -- useful for the breadcrumbs
 */
export const getCourseMaterialPageChapterAndCourseInformationOptions = (
  options: Options<GetCourseMaterialPageChapterAndCourseInformationData>,
) =>
  queryOptions<
    GetCourseMaterialPageChapterAndCourseInformationResponse,
    DefaultError,
    GetCourseMaterialPageChapterAndCourseInformationResponse,
    ReturnType<typeof getCourseMaterialPageChapterAndCourseInformationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageChapterAndCourseInformation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageChapterAndCourseInformationQueryKey(options),
  })

export const getCourseMaterialChapterFrontPageQueryKey = (
  options: Options<GetCourseMaterialChapterFrontPageData>,
) => createQueryKey("getCourseMaterialChapterFrontPage", options)

/**
 *
 * GET /api/v0/course-material/page/{page_id}
 */
export const getCourseMaterialChapterFrontPageOptions = (
  options: Options<GetCourseMaterialChapterFrontPageData>,
) =>
  queryOptions<
    GetCourseMaterialChapterFrontPageResponse,
    DefaultError,
    GetCourseMaterialChapterFrontPageResponse,
    ReturnType<typeof getCourseMaterialChapterFrontPageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialChapterFrontPage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialChapterFrontPageQueryKey(options),
  })

export const getCourseMaterialIsPageChapterFrontPageQueryKey = (
  options: Options<GetCourseMaterialIsPageChapterFrontPageData>,
) => createQueryKey("getCourseMaterialIsPageChapterFrontPage", options)

export const getCourseMaterialIsPageChapterFrontPageOptions = (
  options: Options<GetCourseMaterialIsPageChapterFrontPageData>,
) =>
  queryOptions<
    GetCourseMaterialIsPageChapterFrontPageResponse,
    DefaultError,
    GetCourseMaterialIsPageChapterFrontPageResponse,
    ReturnType<typeof getCourseMaterialIsPageChapterFrontPageQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialIsPageChapterFrontPage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialIsPageChapterFrontPageQueryKey(options),
  })

export const getCourseMaterialPageNavigationQueryKey = (
  options: Options<GetCourseMaterialPageNavigationData>,
) => createQueryKey("getCourseMaterialPageNavigation", options)

/**
 *
 * GET /api/v0/course-material/pages/:page_id/page-navigation - tells what's the next page, previous page, and the chapter front page given a page id.
 */
export const getCourseMaterialPageNavigationOptions = (
  options: Options<GetCourseMaterialPageNavigationData>,
) =>
  queryOptions<
    GetCourseMaterialPageNavigationResponse,
    DefaultError,
    GetCourseMaterialPageNavigationResponse,
    ReturnType<typeof getCourseMaterialPageNavigationQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageNavigation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageNavigationQueryKey(options),
  })

export const getCourseMaterialPageUrlPathQueryKey = (
  options: Options<GetCourseMaterialPageUrlPathData>,
) => createQueryKey("getCourseMaterialPageUrlPath", options)

/**
 *
 * GET /api/v0/course-material/pages/:page_id/url-path - returns the page's URL path.
 * # Example
 * ```json
 * "chapter-1/page-2"
 * ```
 */
export const getCourseMaterialPageUrlPathOptions = (
  options: Options<GetCourseMaterialPageUrlPathData>,
) =>
  queryOptions<
    GetCourseMaterialPageUrlPathResponse,
    DefaultError,
    GetCourseMaterialPageUrlPathResponse,
    ReturnType<typeof getCourseMaterialPageUrlPathQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialPageUrlPath({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialPageUrlPathQueryKey(options),
  })

/**
 *
 * POST `/api/v0/course-material/proposed-edits/:course-id`
 */
export const postCourseMaterialProposedEditsMutation = (
  options?: Partial<Options<PostCourseMaterialProposedEditsData>>,
): UseMutationOptions<unknown, DefaultError, Options<PostCourseMaterialProposedEditsData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<PostCourseMaterialProposedEditsData>
  > = {
    mutationFn: async (fnOptions) =>
      await postCourseMaterialProposedEdits({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

/**
 *
 * POST `/api/v0/course-material/user-details/update-user-info` - Updates the users information such as email, name, country and email communication consent
 */
export const updateCourseMaterialUserInfoMutation = (
  options?: Partial<Options<UpdateCourseMaterialUserInfoData>>,
): UseMutationOptions<
  UpdateCourseMaterialUserInfoResponse,
  DefaultError,
  Options<UpdateCourseMaterialUserInfoData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCourseMaterialUserInfoResponse,
    DefaultError,
    Options<UpdateCourseMaterialUserInfoData>
  > = {
    mutationFn: async (fnOptions) =>
      await updateCourseMaterialUserInfo({
        ...options,
        ...fnOptions,
        throwOnError: true,
      }),
  }
  return mutationOptions
}

export const getCourseMaterialAuthenticatedUserDetailsQueryKey = (
  options?: Options<GetCourseMaterialAuthenticatedUserDetailsData>,
) => createQueryKey("getCourseMaterialAuthenticatedUserDetails", options)

/**
 *
 * GET `/api/v0/course-material/user-details/user` - Find user details by user id
 */
export const getCourseMaterialAuthenticatedUserDetailsOptions = (
  options?: Options<GetCourseMaterialAuthenticatedUserDetailsData>,
) =>
  queryOptions<
    GetCourseMaterialAuthenticatedUserDetailsResponse,
    DefaultError,
    GetCourseMaterialAuthenticatedUserDetailsResponse,
    ReturnType<typeof getCourseMaterialAuthenticatedUserDetailsQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialAuthenticatedUserDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialAuthenticatedUserDetailsQueryKey(options),
  })

export const getCourseMaterialCountryFromIpQueryKey = (
  options?: Options<GetCourseMaterialCountryFromIpData>,
) => createQueryKey("getCourseMaterialCountryFromIp", options)

/**
 *
 * GET `/api/v0/course-material/user-details/users-ip-country` - Find users country by their IP  address
 */
export const getCourseMaterialCountryFromIpOptions = (
  options?: Options<GetCourseMaterialCountryFromIpData>,
) =>
  queryOptions<
    GetCourseMaterialCountryFromIpResponse,
    DefaultError,
    GetCourseMaterialCountryFromIpResponse,
    ReturnType<typeof getCourseMaterialCountryFromIpQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) =>
      await getCourseMaterialCountryFromIp({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      }),
    queryKey: getCourseMaterialCountryFromIpQueryKey(options),
  })
